import { render, staticRenderFns } from "./TravelRoutes.vue?vue&type=template&id=38822602&scoped=true"
import script from "./TravelRoutes.vue?vue&type=script&lang=js"
export * from "./TravelRoutes.vue?vue&type=script&lang=js"
import style0 from "./TravelRoutes.vue?vue&type=style&index=0&id=38822602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38822602",
  null
  
)

export default component.exports